/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { Box } from '@mui/material';

export interface VideoProps {
  link: string;
  testId?: string;
  width?: number | string;
  height?: number;
}

export const Video = ({ link, testId, width, height }: VideoProps) => {
  const isYouTubeVideo = link.includes('youtube.com');

  return (
    <Box data-testid={testId} width={width || '100%'} height={height || '100%'}>
      {isYouTubeVideo ? (
        <iframe
          width="100%"
          height="100%"
          src={link}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
          style={{ borderRadius: 12 }}
        />
      ) : (
        <video src={link} controls width="100%" height="100%" style={{ borderRadius: 12 }} />
      )}
    </Box>
  );
};
